import { render, staticRenderFns } from "./RoundedShareIcon.vue?vue&type=template&id=c8d31674&"
import script from "./RoundedShareIcon.vue?vue&type=script&lang=js&"
export * from "./RoundedShareIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports